export { hasSomeRole, realmRoles, userFullname } from '@medcom/shared-ui/utils/user.ts';

import { hasRealmRole } from '@medcom/shared-ui/utils/user.ts';
import type { User } from 'oidc-client-ts';

export enum Role {
  ROLE_BEF_MEDCOM = 'ROLE_BEF_MEDCOM',
  ROLE_BEF_USER = 'ROLE_BEF_USER',
}

export const hasAnyRelevantRole = (user: User | null | undefined): boolean => !!user && Object.keys(Role).some(r => hasRealmRole(user, r));

export const translateRole = (role: Role | string) => {
  switch (role) {
    case Role.ROLE_BEF_MEDCOM:
      return 'Medcom Administrator';
    case Role.ROLE_BEF_USER:
      return 'Befunde Lesezugriff';
    default:
      return 'Unbekannte Rolle';
  }
};
